export const html = (strings, ...values) => {
    return new DOMParser().parseFromString(
        String.raw({ raw: strings }, ...values), "text/html"
    ).body.firstChild
}

// Non cryptographically secure
export function uuid() {
    return Array.from({ length: 36 })
        .map((_, i) => {
            if (i == 8 || i == 13 || i == 18 || i == 23) {
                return "-"
            } else if (i == 14) {
                return "4"
            } else if (i == 19) {
                return (Math.floor(Math.random() * 4) + 8).toString(16)
            } else {
                return Math.floor(Math.random() * 16).toString(16)
            }
        })
        .join("")
}

/**
 * @param a {string}
 * @param b {string}
 */
export function similiar(a, b) {
    a = a.toLowerCase()
    b = b.toLowerCase()

    return a.includes(b) || b.includes(a)
}

export function getScrollbarWidth() {
    const outer = document.createElement("div")
    outer.style.visibility = "hidden"
    outer.style.overflow = "scroll" // Force scrollbar
    outer.style.msOverflowStyle = "scrollbar" // For IE/Edge

    const inner = document.createElement("div")
    outer.appendChild(inner)

    document.body.appendChild(outer)

    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth)
    outer.remove()

    return scrollbarWidth
}
